<template>
    <div class="main-questions">
        <div class="input-group" style="display: flex">
            <div class="col-sm-12">
                <input id="btn-input" type="text" name="message" class="form-control input-sm" placeholder="Ingresa tu pregunta..." v-model="question" @keyup.enter="sendQuestion">
            </div>

            <div class="col-sm-12 mt-3">
                <span class="input-group-btn" style="display: flex; flex-direction: row; justify-content: flex-end">
                    <button class="btn btn-primary btn-sm mr-2" id="btn-chat" @click="sendQuestion" v-if="stateButon === false">
                        Enviar
                    </button>
                    <button class="btn btn-primary btn-sm mr-2" disabled  v-else>
                        Espere...
                    </button>
                    <button class="btn btn-dark btn-sm"  @click="$emit('close')">
                        Cancelar
                    </button>
                </span>
            </div>
        </div>
    </div>

</template>

<script>
    import axios from 'axios'
    import {mapState, mapGetters} from 'vuex'
    export default {
        name:'NewQuestions',

        data() {
            return {
                question: '',
                stateButon: false
            }
        },
        computed: {
            ...mapState,
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },
            courseId () {
                return localStorage.getItem('mountedCourseId')
            }
        },
        methods: {
            sendQuestion() {
                this.stateButon = true;
                var url = '/api/v1/students/questions/newQuestion';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    user_id: this.userId.id,
                    mounted_course_id: this.courseId,
                    question: this.question,
                }).then(response => {
                    this.$store.commit('questions', response.data);
                    this.$emit('close')
                    this.question = ''
                    this.stateButon = false;
                });
            }
        }    
    }
</script>
<style scoped>
    .main-questions{
        display: flex;
        flex-direction: column;
    }

</style>
